import type { EdgeFinish, Shape } from "../types/product";
import type { Side } from "../types/config";

/** Circles/ovals use the circumference (π·mean diameter) for edge length. */
export function isRound(shape?: Shape): boolean {
  return shape?.id === "cirkel" || shape?.id === "ovaal" || shape?.id === "V006";
}

/** Full geometric perimeter in metres. */
export function perimeterM(
  widthMm: number,
  heightMm: number,
  shape?: Shape,
): number {
  if (isRound(shape)) {
    return (Math.PI * ((widthMm + heightMm) / 2)) / 1000;
  }
  return (2 * (widthMm + heightMm)) / 1000;
}

/** Length of the selected sides only, in metres (top/bottom = width, sides = height). */
export function selectedSidesLengthM(
  widthMm: number,
  heightMm: number,
  sides: Side[],
): number {
  const lengthFor = (s: Side): number =>
    s === "top" || s === "bottom" ? widthMm : heightMm;
  return sides.reduce((sum, s) => sum + lengthFor(s), 0) / 1000;
}

/** Edge finishing cost (raw, unrounded), with the finish minimum applied. */
export function edgeCost(lengthM: number, edge?: EdgeFinish): number {
  if (!edge) return 0;
  let cost = lengthM * edge.pricePerMeter;
  if (edge.minPrice != null) cost = Math.max(cost, edge.minPrice);
  return cost;
}
